import { CasAuthApi, CasProfileApi, getUser as getUserData } from "@jti/rest-api";

export type Purpose = {
  purpose: string;
};

export type UserProfile = {
  isLoggedIn: boolean;
  isAgeVerified: boolean;
  isDeviceRegistered?: boolean;
  hasUserValidPurposes: boolean;
};

export const hasUserValidPurposes = (requiredPurposes: Purpose[] = [], userPurposes: string[]): boolean => {
  if (!Array.isArray(requiredPurposes) || requiredPurposes.length === 0) {
    return true;
  }

  return requiredPurposes.every(({ purpose }) => userPurposes.includes(purpose));
};

export const getUser = async (
  requiredPurposes: Purpose[],
  ageVerificationRequired = false,
  isDeviceRegistrationRequired = false
): Promise<UserProfile | null> => {
  const { ciam_token, is_device_registered } = getUserData();

  if (ciam_token) {
    const { statusCode } = await CasAuthApi.init().validate(ciam_token);

    if (statusCode === 200 || statusCode === 204) {
      const { is_age_verified, purposes } = await CasProfileApi.init().getProfile();

      return {
        isLoggedIn: true,
        isAgeVerified: ageVerificationRequired ? is_age_verified : true,
        isDeviceRegistered: isDeviceRegistrationRequired ? is_device_registered : true,
        hasUserValidPurposes: hasUserValidPurposes(requiredPurposes, purposes),
      };
    }
  }

  return null;
};
